import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth.js';
import { Input } from '../ui/Input.js';
import { Button } from '../ui/Button.js';
import { internalPath, type From } from '../lib/redirect.js';

export function Login(): React.ReactElement {
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Set by RequireAuth when it bounced a deep link here.
  const from = (location.state as { from?: From } | null)?.from;
  const target = internalPath(from);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    try {
      await login(password);
      navigate(target, { replace: true });
    } catch {
      /* error surfaced via store */
    }
  }

  return (
    <main className="cadre cadre-etroit min-h-screen flex items-center">
      <form onSubmit={onSubmit} className="carte w-full">
        <div className="pile">
        <h1 className="text-2xl text-primary-ink">nota</h1>
        <div className="champ">
          <label className="champ-libelle" htmlFor="login-password">
            Password
          </label>
          <Input
            id="login-password"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            aria-invalid={error ? true : undefined}
            aria-describedby="login-error"
          />
          <p className="champ-erreur" id="login-error" role="alert">
            {error}
          </p>
        </div>
        <Button type="submit" className="bouton-large" loading={loading}>
          Sign in
        </Button>
        </div>
      </form>
    </main>
  );
}
